import React from "react";
import { Link } from "react-router-dom";

const GatewayQuestPanel = () => (
  <section
    className="dg-panel dg-panel--dense dg-gold-ring dg-premium-ring dg-premium-ring--interactive dg-quest-panel dg-quest-panel--premium"
    aria-labelledby="gateway-quest-heading"
  >
    <h2 id="gateway-quest-heading" className="dg-panel__title serif">
      Quests &amp; Progression
    </h2>
    <p className="dg-label-up dg-muted" style={{ margin: "0 0 8px" }}>
      Quest system coming online.
    </p>
    <p className="dg-quest-empty serif" style={{ margin: "0 0 14px", color: "rgba(232, 237, 245, 0.72)", fontSize: "0.85rem" }}>
      No active quests yet. When live progression returns, your milestones will appear here.
    </p>
    <Link to="/dashboard/quests" className="dg-btn dg-btn--blue-outline dg-btn--compact dg-btn--wide dg-btn--game dg-btn--sweep">
      Open Quest Log <i className="fas fa-arrow-right dg-btn__icon" aria-hidden />
    </Link>
  </section>
);

export default GatewayQuestPanel;
